<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="ventrncot"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confventrncot" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>

<div class="p-grid" style="width: 99%;">
    <div class="p-col-12">
        <app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonRegresar]="btnRegresar"
            [botonBorrar]="btnBorrar" (signal)="manejarSenales($event)" [botonAnterior]="botonAnterior"
            [botonPrimero]="botonPrimero" [botonUltimo]="botonUltimo" [botonSiguiente]="botonSiguiente"
            [barraBotones3Alt]="false" [barraBotones3]="true" [barraBotonesAsiCon]="false" [botonBinocular]="true"
            [botonBuscar]="false" [botonAlmacenardoc]="false" [botonAnular]="botonAnular"
            [botonAutorizarPermanente]="true" [botonAnularPermanente]="false">
        </app-invmaebarra>
    </div>
    <div class="divgrups2" style="margin-top: -10px; margin-bottom: -10px;">
        <div class="p-col-12">
            <div class="p-grid" style="margin-top: -10px; margin-bottom: -10px;">
                <div class="p-col-2">
                    <input type="text" pInputText
                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].TRNCOTIZA_NUMERO" [disabled]="true"
                        autocomplete="off">
                </div>
                <div class="p-col-1">
                </div>
                <div class="p-col-2">
                </div>
                <div class="p-col-1">
                    <input type="text" pInputText style="background-color: darkblue; font-weight: bold; color: white;"
                        [disabled]="true" [(ngModel)]="ventrncotizacionService.trncotiza[indicador].TRNCOTIZA_ESTADO"
                        autocomplete="off">
                </div>
                <div class="p-col-2">
                </div>
                <div class="p-col-2">
                </div>
                <div class="p-col-2">
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12">
        <p-tabView [(activeIndex)]="activeIndex" (onChange)="changeTabs()">
            <p-tabPanel header="Cotización">
                <div class="divgrups" id="divPrincipal">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Comprobante:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" id="TRNCOTIZA_COMPROBANTE" (keydown.enter)="cambiarFoco($event)"
                                        (input)="cambio($event)" [disabled]="boolcomprobante" maxlength="20"
                                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].TRNCOTIZA_COMPROBANTE" pInputText
                                        style="width: 100%" autocomplete="off">
                                </div>
                                <div class="p-col-3"></div>
                                <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div>
                                <div class="p-col-1">
                                    <p-calendar [inputStyle]="{'width': '100%'}" dateFormat="dd/mm/yy"
                                        (ngModelChange)="cambio($event)"
                                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].TRNCOTIZA_FECHAEMISION">
                                    </p-calendar>
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <span>Fecha de Entrega:</span>
                                </div>
                                <div class="p-col-1">
                                    <p-calendar [inputStyle]="{'width': '100%'}" dateFormat="dd/mm/yy"
                                        (ngModelChange)="cambio($event)"
                                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].TRNCOTIZA_FECHAENTREGA">
                                    </p-calendar>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Cliente:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" pInputText style="width: 100%" id="CLI_CODIGO"
                                        (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                        maxlength="20"
                                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].CLI_CODIGO"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="abrircliente(ventrncotizacionService.trncotiza[indicador].CLI_CODIGO)"></button>
                                </div>
                                <div class="p-col-3">
                                    <span
                                        style="width: 100%;">{{ventrncotizacionService.trncotiza[indicador].CLI_NOMBRE}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Vendedor:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" pInputText style="width: 100%" id="VEN_CODIGO"
                                        (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                        maxlength="5"
                                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].VEN_CODIGO"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="abrirvendedor(ventrncotizacionService.trncotiza[indicador].VEN_CODIGO)"></button>
                                </div>
                                <div class="p-col-3">
                                    <span
                                        style="width: 100%;">{{ventrncotizacionService.trncotiza[indicador].VEN_NOMBRE}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -15px;  margin-bottom: -15px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Categoria:</span>
                                </div>
                                <div class="p-col-2">
                                    <input type="text" pInputText style="width: 100%" id="GRUP_CODIGO"
                                        (keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
                                        maxlength="30"
                                        [(ngModel)]="ventrncotizacionService.trncotiza[indicador].GRUP_CODIGO"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <button type="button"
                                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                        (click)="abrirgrupo(ventrncotizacionService.trncotiza[indicador].GRUP_CODIGO)"></button>
                                </div>
                                <div class="p-col-2">
                                    <span
                                        style="width: 100%;">{{ventrncotizacionService.trncotiza[indicador].GRUP_NOMBRE}}</span>
                                </div>
                                <div class="p-col-2">
                                    <p-checkbox label="Impresión Digital" binary="true"
                                        (click)="cambio($event)" [(ngModel)]="boolimpdig" >
                                    </p-checkbox>
                                </div>
                                <div class="p-col-2">
                                    <p-checkbox label="Impresión Offset" binary="true"
                                        (click)="cambio($event)" [(ngModel)]="boolimpoffset" >
                                    </p-checkbox>
                                </div>
                                <div class="p-col-1">
                                    <p-checkbox label="Plotter" binary="true"
                                        (click)="cambio($event)" [(ngModel)]="boolplotter" >
                                    </p-checkbox>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <p-tabView [(activeIndex)]="tabActiva">
                    <p-tabPanel *ngFor="
                    let item of ventrncotizacionService.trncotiza[indicador].cotizaciones
                    let i = index"
                    [header]="'Cotización'+(i+1)"
                    >
                    <app-venenccotizacion
                    [encabezado]="item"
                    [decimalesCantidad]="ventrncotizacionService.decimalesCantidad"
                    [decimalesCosto]="ventrncotizacionService.decimalesCosto"
                    [decimalesTotal]="ventrncotizacionService.decimalesTotal"
                    [decimalesPrecio]="ventrncotizacionService.decimalesPrecio"
                    [decimalesTOTALFAC]="ventrncotizacionService.decimalesTOTALFAC"
                    [TIPDET]="TIPDET"
                    [modo]="modo">
                    
                    </app-venenccotizacion>
                    </p-tabPanel>
                </p-tabView>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>

<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
		[busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<div style="position: fixed;
			z-index: 999;
			height: 2em;
			width: 2em;
			overflow: visible;
			margin: auto;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;">
	<p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
	</p-progressSpinner>
	
</div>